import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface LearnMoreDialogProps {
  open: boolean;
  onClose: () => void;
}

const LearnMoreDialog: React.FC<LearnMoreDialogProps> = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: {
        backgroundColor: 'background.paper',
        color: 'text.primary',
      },
    }}
  >
    <DialogTitle>
      <Typography variant="h6" component="h2">
        About Multi Ask AI
      </Typography>
    </DialogTitle>
    <DialogContent>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="subtitle1"
          component="h3"
          sx={{ mb: 1, fontWeight: 500 }}
        >
          Overview
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Multi Ask AI is a powerful analysis tool that helps you extract
          insights from multiple recordings simultaneously. Simply select your
          recordings and ask questions to get comprehensive analysis of your
          content.
        </Typography>

        <Typography
          variant="subtitle1"
          component="h3"
          sx={{ mb: 1, fontWeight: 500 }}
        >
          Key Features
        </Typography>
        <Box component="ul" sx={{ pl: 2, mb: 2 }}>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            Analyze up to 10 recordings at once for efficient content processing
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            Get AI-powered insights with source citations linked to specific
            timestamps
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            View source content directly by clicking on citations
          </Typography>
          <Typography component="li" variant="body2">
            Export or copy analysis results for easy sharing
          </Typography>
        </Box>

        <Typography
          variant="subtitle1"
          component="h3"
          sx={{ mb: 1, fontWeight: 500 }}
        >
          How to Use
        </Typography>
        <Box component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            Select up to 10 recordings from your library
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            Type your question or click a suggestion chip
          </Typography>
          <Typography component="li" variant="body2">
            Review the AI analysis with linked sources and timestamps
          </Typography>
        </Box>
      </Box>
    </DialogContent>
  </Dialog>
);

export default LearnMoreDialog;
